// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2HtA6","footer":"Form_footer__2o2PX"};